import { defineStore } from 'pinia'
import { ref } from 'vue'

import api from '@axios'

import type { VerificationRecovery } from './types'

export type RecoverAction =
  | 'pick_patient'
  | 'skip_patients'
  | 'poll_discovery'

export interface RecoverExtra {
  patient_uuid?: string
}

export const useIvRecoveryStore = defineStore('iv-recovery', () => {
  const recovery = ref<VerificationRecovery | null>(null)
  const busy = ref(false)

  function setFromVerifyError(err: unknown): boolean {
    const payload = (err as { response?: { data?: { recovery?: VerificationRecovery } } })
      ?.response?.data?.recovery

    if (!payload)
      return false

    recovery.value = payload

    return true
  }

  async function recover(action: RecoverAction, extra?: RecoverExtra) {
    const sessionUuid = recovery.value?.session_uuid
    if (!sessionUuid)
      throw new Error('No recovery session')

    busy.value = true
    try {
      const { data } = await api.post(`/insurance/verify/${sessionUuid}/recover`, {
        action,
        ...extra,
      })

      const payload = data.data ?? data

      if (payload?.kind)
        recovery.value = payload

      return payload
    } finally {
      busy.value = false
    }
  }

  function reset() {
    recovery.value = null
    busy.value = false
  }

  return {
    recovery,
    busy,
    setFromVerifyError,
    recover,
    reset,
  }
})
